// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {useToast, MutationError} from '@supermove/hooks';
import {ClaimModel, ProjectModel} from '@supermove/models';

// Shared
import DrawerWithAction from '@shared/design/components/Drawer/DrawerWithAction';
import SuccessToast from '@shared/design/components/Toast/SuccessToast';
import ClaimForm from '@shared/modules/Claim/forms/ClaimForm';
import useCreateClaimMutation from '@shared/modules/Claim/hooks/useCreateClaimMutation';
import ProjectClaimDrawerFields from '@shared/modules/Project/components/Claim/ProjectClaimDrawerFields';

const CreateProjectClaimDrawer = ({
  project,
  isOpen,
  handleClose,
  onSuccess,
}: {
  project: ProjectModel;
  isOpen: boolean;
  handleClose: () => void;
  onSuccess: () => void;
}) => {
  const createClaimSuccessToast = useToast({
    ToastComponent: SuccessToast,
  });

  const claimForm = ClaimForm.new({organizationId: project.organizationId, projectId: project.id});
  const {form, handleSubmit, submitting} = useCreateClaimMutation({
    claimForm,
    onSuccess: ({claim}: {claim: ClaimModel}) => {
      createClaimSuccessToast.handleToast({message: `Claim ${claim.identifier} created`});
      onSuccess();
    },
    onError: (errors: MutationError[]) => console.log({errors}),
  });

  return (
    <DrawerWithAction
      isOpen={isOpen}
      handleClose={handleClose}
      width={DrawerWithAction.WIDTH.MEDIUM}
      headerText={'Create Claim'}
      handleSubmit={handleSubmit}
      primaryActionText={'Create'}
      isSubmitting={submitting}
      isDisabled={ClaimForm.getIsUploadingAttachment(form.values.claimForm)}
    >
      <ProjectClaimDrawerFields
        form={form}
        field={'claimForm'}
        projectUuid={project.uuid}
        isOpen={isOpen}
      />
    </DrawerWithAction>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
CreateProjectClaimDrawer.fragment = gql`
  fragment CreateProjectClaimDrawer on Project {
    id
    uuid
    organizationId
  }
`;

export default CreateProjectClaimDrawer;
